import React, { Suspense, lazy } from 'react';
import { ThreeDots } from "react-loader-spinner";

// Lazy load the TinyMCE Editor component
const Editor = lazy(() => import('@tinymce/tinymce-react').then(module => ({ default: module.Editor })));

// Loading component while TinyMCE loads
const EditorLoading = () => (
  <div className="flex justify-center items-center h-32 bg-gray-50 rounded-md border-2 border-dashed border-gray-300">
    <div className="text-center">
      <ThreeDots visible={true} color="#6366f1" width={50} />
      <p className="text-sm text-gray-500 mt-2">Loading editor...</p>
    </div>
  </div>
);

// Lazy TinyMCE wrapper component
const LazyTinyMCE = (props) => {
  return (
    <Suspense fallback={<EditorLoading />}>
      <Editor {...props} />
    </Suspense>
  );
};

export default LazyTinyMCE;